import { Component } from '@angular/core';
import { ApiService } from "../../services/api.service";
import { InAppBrowser } from "@ionic-native/in-app-browser";

@Component({
  selector: 'page-company-files',
  templateUrl: 'company-files.html',
})
export class CompanyFilesPage {

  public data: any = [];
  public expanded:any = [];

  constructor(
    public api: ApiService,
    public iab: InAppBrowser
  ) {
  }

  private load(){
    this.api.getCompanyFiles().then((data: any) => {
      this.data = data.company_files;
      console.log(this.data);
    });
  }

  public ionViewDidEnter() {
    console.log('ionViewDidLoad CompanyFilesPage');
    this.load();
  }

  public itemClick(event, item){
    event.stopPropagation();
    if(item.download_url){
      this.iab.create(item.download_url, '_system');
    } else {
      this.toggleExpanded(item)
    }
  }

  public downloadFile(item){
    if(item.download_url){
      this.iab.create(item.download_url, '_system');
    }
  }

  public isExpanded(item){
    let id = item.company_file_id.toString();
    if(id == '0'){
      return true;
    }
    return (this.expanded.indexOf(id) > -1);
  }

  public toggleExpanded(item){
    let id = item.company_file_id.toString();
    console.log('toggle: ' + id);
    if(this.isExpanded(item)){
      let index = this.expanded.indexOf(id);
      if(index > -1){
        this.expanded.splice(index, 1);
      }
    } else {
      this.expanded.push(id);
    }
    console.log(this.expanded);
  }

}



// WEBPACK FOOTER //
// ./src/pages/company-files/company-files.ts